export enum Events {
  LOGIN_ERROR = 'loginError',
  SESSION_EXPIRED = 'session_expired'
}
